// Source: src/components/GizmoEdgeSection.tsx. Values include intentional inline spacing.
const en = {
  "s1": "Distributed Computing",
  "s2": "GizmoEdge Logo",
  "s3": "The distributed SQL engine that scales from edge devices to 1000-node clusters. Run anywhere - cloud, on-premises, or edge IoT devices.",
  "s4": "Run Anywhere",
  "s5": "Cloud, on-prem, or edge",
  "s6": "1000+ Workers",
  "s7": "Massive parallelism",
  "s8": "Edge IoT Ready",
  "s9": "iPhones, laptops, and more",
  "s10": "DuckDB Core",
  "s11": "Battle-tested engine",
  "s12": "Explore GizmoEdge",
  "s13": "Distributed Architecture",
  "s14": "Coordinator",
  "s15": "W",
  "s16": "1 Trillion Row Challenge",
  "s17": "1,000 workers ",
  "s18": "on Azure"
};
const pt: typeof en = {
  "s1": "Computação distribuída",
  "s2": "Logo do GizmoEdge",
  "s3": "O mecanismo SQL distribuído que escala de dispositivos de borda a clusters de 1.000 nós. Execute em qualquer lugar — na nuvem, em ambiente local ou em dispositivos IoT de borda.",
  "s4": "Execute em qualquer lugar",
  "s5": "Nuvem, ambiente local ou borda",
  "s6": "Mais de 1.000 workers",
  "s7": "Paralelismo em grande escala",
  "s8": "Pronto para IoT de borda",
  "s9": "iPhones, notebooks e mais",
  "s10": "Núcleo DuckDB",
  "s11": "Mecanismo comprovado em uso",
  "s12": "Conheça o GizmoEdge",
  "s13": "Arquitetura distribuída",
  "s14": "Coordenador",
  "s15": "W",
  "s16": "Desafio de 1 trilhão de linhas",
  "s17": "1.000 workers ",
  "s18": "na Azure"
};
export default { en, 'pt-BR': pt };
